export const getDropdownSafeDialogSx = (
  paperOverrides: Record<string, unknown> = {}
) => ({
  "& .MuiDialog-container": {
    overflow: "visible",
  },
  "& .MuiDialog-paper": {
    overflow: "visible",
    position: "relative",
    ...paperOverrides,
  },
});
